import { useEffect } from 'react';
import { setFavicon } from '../../shared/utils/setFavicon';

/**
 * Ставит favicon на основе типа REST сервера из конфига.
 * IndorPower -> favicon_indor_power.svg, иначе -> favicon_indor_road.svg
 */
export function useFavicon(restServerType?: string | null) {
    useEffect(() => {

        const publicUrl = process.env.PUBLIC_URL ?? '';
        const urlPattern = `${publicUrl}/assets/images/favicon`;
        const url =
            restServerType === 'IndorPower'
                ? `${urlPattern}/favicon_indor_power.svg`
                : `${urlPattern}/favicon_indor_road.svg`;

        setFavicon(url, { bustCache: true });
    }, [restServerType]);
}




